import homePage from '@/components/pages/index'
import gameNew from '@/components/pages/gameNew'
import life from '@/components/pages/life'
import introduce from '@/components/pages/introduce'
import dynamic from '@/components/pages/dynamic'
import publish from '@/components/pages/publish'

export default [
    {
        path: '/',
        label: 'Home Page',
        key: 'index',
        component: homePage
    },
    {
        path: '/introduce',
        label: 'About Betta',
        key: 'introduce',
        component: introduce,
        children: [
            {
                path: '/introduce?active=intro1',
                key: 'intro1',
                label: 'About Betta', //公司简介
            },
            {
                path: '/introduce?active=intro2',
                key: 'intro2',
                label: 'Visions and Missions', //愿景使命
            },
            {
                path: '/introduce?active=intro3',
                key: 'intro3',
                label: 'Core Value',//核心价值&工作理念
            },
            {
                path: '/introduce?active=intro4',
                key: 'intro4',
                label: 'Working Environment',
            }
        ]
    },
    {
        path: '/game',
        label: 'Games',
        key: 'game',
        component: gameNew
    },
    {
        path: '/publish',
        label: 'Publish',
        key: 'publish',
        component: publish,
    },
    {
        path: '/life',
        label: 'Life',
        key: 'life',
        component: life
    },
    {
        path: '/dynamic',
        label: 'Newsletters',
        key: 'dynamic',
        component: dynamic
    },
    {
        path: '/joinus',
        label: 'Career',
        key: 'joinus'
    }
]



// WEBPACK FOOTER //
// ./src/router/routerLists.js